import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_68: FaireProductEntity = {
  token: "legacy_prod_abbott-68",
  type: "product",
  name: "Marine Kingdom Lined Notebook A5",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9a14dc8ceff1a498abd306d32f0f01ae324de34f753d85c926a48ef1f914eb3d.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
